export default "__VITE_ASSET__QoC9AFv$__"